/* Wonder Jacket — AJAX add-to-cart that opens Dawn's cart drawer.
   Falls back to a normal form POST whenever the drawer isn't on the page. */
(() => {
  // the file is referenced by more than one section — only bind once
  if (window.__wjCartBound) return;
  window.__wjCartBound = true;

  const drawer = () => document.querySelector('cart-drawer');

  const sectionsFor = (el) =>
    typeof el.getSectionsToRender === 'function'
      ? el.getSectionsToRender().map((s) => s.id)
      : ['cart-drawer', 'cart-icon-bubble'];

  const setBusy = (form, busy) => {
    const btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    btn.classList.toggle('is-loading', busy);
    btn.disabled = busy;
  };

  const showError = (form, message) => {
    let box = form.querySelector('[data-wj-cart-error]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-wj-cart-error', '');
      box.className = 'wj-cart-error';
      form.appendChild(box);
    }
    box.textContent = message;
    box.hidden = false;
  };

  const clearError = (form) => {
    const box = form.querySelector('[data-wj-cart-error]');
    if (box) box.hidden = true;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-wj-cart-form]');
    if (!form) return;

    const el = drawer();
    if (!el) return; // cart type is page or notification — let the browser post

    event.preventDefault();
    clearError(form);
    setBusy(form, true);

    const body = new FormData(form);
    body.append('sections', sectionsFor(el).join(','));
    body.append('sections_url', window.location.pathname);

    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    try {
      const res = await fetch(`${addUrl}.js`, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const data = await res.json();

      if (data.status) {
        showError(form, data.description || data.message || 'This item could not be added to your cart.');
        return;
      }

      el.classList.remove('is-empty');
      if (typeof el.renderContents === 'function') {
        el.renderContents(data);
      } else {
        el.open?.();
      }

      document.dispatchEvent(new CustomEvent('wj:cart:added', { detail: data }));
    } catch (e) {
      // network failure — fall back to the real form so the customer isn't stuck
      form.removeAttribute('data-wj-cart-form');
      form.submit();
    } finally {
      setBusy(form, false);
    }
  });
})();
